import { getColumnsByNames, } from './all-top10-columns-config';

export const topBlockedOrAllowedUrls = getColumnsByNames([
    { name: 'category', width: '20%' },
    { name: 'url', width: '30%'},
    { name: 'count', width: '47%' }
]);